/**
 * @fileoverview IconRenderer component for the Storyteller web application.
 * Renders an icon based on the provided icon name.
 *
 * @example
 * // Basic usage
 * <IconRenderer name="icon-name" />
 */

import { LabelProps, rankWith, uiTypeIs } from '@jsonforms/core'
import { withJsonFormsLabelProps } from '@jsonforms/react'
import { VanillaRendererProps, withVanillaControlProps } from '@jsonforms/vanilla-renderers'
import { Icon } from '../../../Icon'

/**
 * @function IconRenderer
 * @description Component for rendering an icon.
 * @param {LabelProps & VanillaRendererProps} props - The props for the IconRenderer component.
 * @returns {JSX.Element} The IconRenderer component.
 */
function IconRenderer(props: LabelProps & VanillaRendererProps) {
    const { text } = props
    return <Icon name={text as keyof typeof Novoic.SupportedIcons} />
}

export const IconTester = rankWith(3, uiTypeIs('Icon'))

export default withVanillaControlProps(withJsonFormsLabelProps(IconRenderer))
